var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.556396484375,
    height: 15.556396484375,
    viewBox: "0 0 15.556396484375 15.556396484375",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    opacity: 1,
    d: "M9.31025e-05 1.41421L14.1422 15.5563L15.5564 14.1421L1.41431 0L9.31025e-05 1.41421Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 3",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    opacity: 1,
    d: "M14.1422 -2.89679e-05L4.76837e-05 14.1421L1.41426 15.5563L15.5564 1.41418L14.1422 -2.89679e-05Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.047a19f269479c8c9ea83d9cd3ac4c5d.svg";
export { ForwardRef as ReactComponent };